// stores/cart.js
import { defineStore } from 'pinia';
import { useStorage } from '@vueuse/core';
import { encryptData,decryptData } from '@/utils/encyption';
import useAuthenticatedApi from '@/plugins/useAuthenticatedApi';
import { useUserStore } from './userStore';
import eventBus from '@/utils/eventBus';
import { computed } from 'vue';
import { showToast } from '@/utils/toaster';
import { createCartItemPayload } from './helpers/cart';
import productService from '@/services/productService';
import { getInventoryDetails } from '@/services/easecomServices'
export const useCartStore = defineStore('cart', {
  state: () => ({
    items: useStorage('obf_items', [], localStorage, {
      serializer: {
        read: (v) => decryptData(v) || [],
        write: encryptData
      }
    }),
    downline: useStorage('obf_downline', [], localStorage, {
      serializer: {
        read: (v) => decryptData(v) || [],
        write: encryptData
      }
    }),
    offer: useStorage('obf_offer', [], localStorage, {
      serializer: {
        read: (v) => decryptData(v) || [],
        write: encryptData
      }
    }),
    offerModalStatus: useStorage('obf_offer_modal_status', [], localStorage, {
      serializer: {
        read: (v) => decryptData(v) || [],
        write: encryptData
      }
    }),
    offerMessage: useStorage('obf_offer_message', [], localStorage, {
      serializer: {
        read: (v) => decryptData(v) || [],
        write: encryptData
      }
    })

  }),
  getters: {
    cartItems: (state) => {console.log(state.items,'updated-cart-pinia');return state.items},
    totalQuantity: (state) =>
      state.items.reduce((totalQuantity, item) => {
        const quantity = parseInt(item.quantity, 10); // Convert item.quantity to an integer
        return totalQuantity + quantity;
      }, 0),
    totalPv: (state) =>
      state.items.reduce((totalPv, item) => {
        const pv = (item.cv || (item.detail?.additional?.is_cv && (item.detail?.isFreeItem || item.detail?.isAddedItem)) || false)?0:parseFloat((item.pv)); 
        const quantity = parseInt(item.quantity, 10); // Convert item.quantity to an integer
        return parseFloat((totalPv + Number(pv * quantity)).toFixed(4));
      }, 0),
    totalCheckoutPv: (state) =>
      state.items.reduce((totalPv, item) => {
        let pv = (item.detail?.total_pv);
        if(item.detail.cv){
          pv=0;
        }
        return parseFloat((totalPv + pv).toFixed(4));
      }, 0),
      totalCheckoutDiscount: (state) =>
      state.items.reduce((total, item) => {
        const discount = (item.detail?.discount_amount);
        return total + discount;
      }, 0),
    totalItems: (state) => state.items.length,
    getUserDownline: (state) => state.downline,
    getAppliedOffer: (state) => state.offer,
    getOfferModalStatus: (state) => state.offerModalStatus,
    offerAppliedMessage:(state)=>state.offerMessage,
    totalPoints :(state) =>
      state.items.reduce((totalPoints,item)=>{
        const points = Number(item.detail?.tax_category_id);
        // alert(parseInt(item.detail?.tax_category_id))
        return Number(totalPoints)+ Number(points);
      },0)
    //    {
    //   return state.items
    //     .filter(item => item.detail?.tax_category_id)  // Filter items that have a tax_category_id
    //     .reduce((acc, item) => acc + (item.tax_category_id || 0), 0);  // Sum the totalPoints of filtered items
    // }
    ,
    totalPrice: (state) =>{
      return parseFloat(
        state.items.reduce(
          (total, item) => {
            let finalPrice=null;
            // const itemsNew = state.items.map((p)=>{
            //   if(p.detail?.id == item.detail?.id){
            //     return item
            //   }
            //   return p
            // });
            // const newpointsProducts = itemsNew.reduce((total, item) => {
            //   return item.detail?.cv ? total + item.quantity : total;
            // }, 0);
            const originalPrice = parseFloat(item.detail?.base_price) * item.quantity;
            if (parseInt(item.detail?.discount_percent)) {
              // alert(item.detail?.discount_percent)
              if(item.detail?.discount_amount!=0){
                finalPrice= (Number(item.detail.price_after_discount) * Number(item.quantity));
                // finalPrice= (Number(item.detail.price_after_discount) * Number(item.quantity))-Number(item.detail?.discount_amount);
                if(item.cv){
                  finalPrice=1;
                }
                return (total+finalPrice);
              }else{
                finalPrice= Number(item.detail.price_after_discount) * Number(item.quantity);
                return (total+finalPrice);
              }
            }
            if ((item.cv || (item.detail?.additional?.is_cv && item.detail?.additional?.isFreeItem) || false) && (item.detail?.cp_price ? item.detail?.cp_price : item?.cp_price)) {
              // const feePerItem = 100 / newpointsProducts;
              // const discountedFee = feePerItem * (1 - (item?.detail?.discount_percent || 0) / 100);
              const discountedFee = 1;
              item.updated_base_price=discountedFee;
              item.base_price=discountedFee;
              if (parseInt(item.detail?.discount_percent)) {
                // alert(item.detail?.discount_percent)
                if(item.detail?.discount_amount!=0){
                  finalPrice= (Number(item.detail.price_after_discount) * Number(item.quantity))-Number(item.detail?.discount_amount);
                  return (total+finalPrice);
                }else{
                  finalPrice= item.detail.price_after_discount * Number(item.quantity);
                  return (total+finalPrice);
                }
              }
              finalPrice= discountedFee;
              // finalPrice= discountedFee * item.quantity;
            }
            if(finalPrice==null){
              finalPrice= originalPrice;
            }
            return total + finalPrice;
          //   let base_price =Number(item.base_price ? item.base_price : item.price);
          //   if(item.detail.cv){
          //     const feePerItem = 100 / newpointsProducts;
          // const discountedFee = feePerItem * (1 - (item?.discount_percent || 0) / 100);
          // base_price= discountedFee ;
          //     // base_price=0;
          //     return (total + base_price * Number(item.quantity))
          //   }
          //   return total + base_price * Number(item.quantity)
          },
          0
        ).toFixed(4)
      )
    },
    totalCheckoutPrice: (state) =>{
      return parseFloat(
        state.items.reduce(
          (total, item) => {
            let finalTotal=null;
            // const itemsNew = state.items.map((p)=>{
            //   if(p.detail?.id == item.detail?.id){
            //     return item
            //   }
            //   return p
            // });
            // const newpointsProducts = itemsNew.reduce((total, item) => {
            //   return item.detail?.cv ? total + item.quantity : total;
            // }, 0);
            // const originalPrice = parseFloat(item.price) * item.quantity;
            // if (parseInt(item.detail?.discount_percent)) {
            //   // alert(item.detail?.discount_percent)
            //   if(item.detail?.discount_amount!=0){
            //     finalPrice= (Number(item.detail.price_after_discount) * Number(item.quantity))-Number(item.detail?.discount_amount);
            //     return (total+finalPrice);
            //   }else{
            //     finalPrice= Number(item.detail.price_after_discount) * Number(item.quantity);
            //     return (total+finalPrice);
            //   }
            // }
            // if ((item.detail?.cp_price ? item.detail?.cp_price : item?.cp_price)) {
            //   // const feePerItem = 100 / newpointsProducts;
            //   // const discountedFee = feePerItem * (1 - (item?.detail?.discount_percent || 0) / 100);
            //   const discountedFee = 1;
            //   item.updated_base_price=discountedFee;
            //   item.base_price=discountedFee;
            //   if (parseInt(item.detail?.discount_percent)) {
            //     // alert(item.detail?.discount_percent)
            //     if(item.detail?.discount_amount!=0){
            //       finalPrice= (Number(item.detail.price_after_discount) * Number(item.quantity))-Number(item.detail?.discount_amount);
            //       return (total+finalPrice);
            //     }else{
            //       finalPrice= item.detail.price_after_discount * Number(item.quantity);
            //       return (total+finalPrice);
            //     }
            //   }
            //   finalPrice= discountedFee;
            //   // finalPrice= discountedFee * item.quantity;
            // }
            // if(finalPrice==null){
            //   finalPrice= originalPrice;
            // }
            finalTotal=parseFloat(item.detail?.final_total);
            if(finalTotal==0){
              finalTotal = parseFloat(item.detail?.price_after_discount)* item.detail?.quantity;
              if(item.detail?.cv){
                finalTotal=1;
              }
            }
            return total + finalTotal;
          //   let base_price =Number(item.base_price ? item.base_price : item.price);
          //   if(item.detail.cv){
          //     const feePerItem = 100 / newpointsProducts;
          // const discountedFee = feePerItem * (1 - (item?.discount_percent || 0) / 100);
          // base_price= discountedFee ;
          //     // base_price=0;
          //     return (total + base_price * Number(item.quantity))
          //   }
          //   return total + base_price * Number(item.quantity)
          },
          0
        ).toFixed(4)
      )
    },
    getProductQuantity: (state) => (sku) => {
      const product = state.cartItems.find((item) => item.sku === sku)|| state.items.find(item => item.product_id === sku);
      // alert(product.value);
      return product ? product.quantity : 0;
    }
  },
  actions: {
    destroyCart() {
      this.items = [];
      localStorage.removeItem('obf_items');
      localStorage.clear()
    },
    setCart(items){
      this.items = [...items];
      // console.log(this.items);
    },
    setDownline(downline){
      this.downline = downline;
    },
    setOffer(offer){
      this.offer = offer;
    },
    setOfferModalStatus(status){
      this.offerModalStatus = status;
    },
    setOfferMessage(message){
      this.offerMessage = message;
    },
    async checkInventory(products) {
      try {
        console.log(products, 'Products to check inventory');
          // Get all product codes as a comma-separated string
          // Check if the input is an array or a single product object
          let productArray =products;
          // let sku ;
          // let sku = 'MP0001,MP0002';
          if (Array.isArray(products)) {
            productArray = products;
        } else {
            // If a single product, wrap it in an array
            productArray = [products];
            // sku = 'MP0001'
        }
          const skus = productArray.map(p => p.sku).join(',');
          // const skus = productArray.map(p => p.sku).join(',');
          console.log(skus, 'SKUs');
          
          // Fetch inventory details
          const inventoryDetails = await getInventoryDetails(skus);
          
          if (inventoryDetails && inventoryDetails.data && inventoryDetails.data.inventoryData) {
              // Filter products based on available inventory
              const validProducts = productArray.filter(product => {
                  const inventoryItem = inventoryDetails.data.inventoryData.find(
                      item => item.productCode === product.sku
                  );
                  
                  // Check if the available inventory is greater than or equal to product quantity
                  return inventoryItem && inventoryItem.availableInventory >= product.quantity;
              });

              // this.validProducts = validProducts;
              console.log(validProducts, 'Products with sufficient inventory');
              return true;
            } else {
              console.log('No inventory data found');
              console.log(inventoryDetails.message);
              showToast('',{type:'warning',message:inventoryDetails.message});
              return false;
          }
      } catch (error) {
          console.error('Error:', error);
      }
  },
    async addToCart(product, isFreeItem = false,isAddedItem=false) {
      const existingItem = this.items.find(item => item.product_id === product.sku)|| this.cartItems.find((item) => item.sku === product.sku);
      
      // alert('adding 1')
      if (existingItem && !isFreeItem && !isAddedItem) {
        this.updateExistingCartItem(existingItem,product);
        return;
      }
      
      const userStore = useUserStore();
      
      if (userStore.isLoggedIn) {
        if(await this.checkInventory(product)){
          await this.handlePostLoginCart(product, isFreeItem,isAddedItem);
        }else{
          // showToast('stockFinished');
        }
      } else {
        this.handlePreLoginCart(product);
      }
    },
    checkDiscount(item,product){
      const base_price=Number(item.unitRate);
      const base_pv=item.unitPv?Number(item.unitPv):Number(product.pv);
      // const base_pv=Number(product.detail?.pv);
      const discountAmount = parseFloat(Number(item.unitRate) * Number(item.discount_percentage) / 100);
      let priceAfterDiscount = parseFloat(item.unitRate) - discountAmount;
      if(product.cv){
        priceAfterDiscount = parseFloat(item.unitRate);
      }
    const totalWithDiscount = priceAfterDiscount * Number(item.quantity);
    const taxAmount = (totalWithDiscount * Number(item.tax_percent) / 100);
    const finalTotal = totalWithDiscount + taxAmount;
      const updated = {
        ...product,
        offer_code:item.offer_code,
        discount_percent: item.discount_percentage,
        base_discount_amount: parseFloat((Number(base_price)*(Number(item.discount_percentage)/100)).toFixed(6)),
        dis_per_pv:item?.pv_percentage,
        pv:base_pv - (item.pv_percentage?parseInt(Number(base_pv)*(Number(item.pv_percentage)/100)):0),
        dis_amt_pv:parseInt(Number(base_pv)*(Number(item.pv_percentage)/100)*item.quantity),
        base_dis_amt_pv:parseInt(Number(base_pv)*(Number(item.pv_percentage)/100)),
        base_price: base_price,
        price_after_discount: priceAfterDiscount,
        discount_amount: discountAmount,
        total_with_discount: totalWithDiscount,
        tax_amount: taxAmount,
        final_total: finalTotal
      }
      return updated;
    },
    updateExistingCartItem(existingItem,product) {
      let basePv = existingItem.cv ? 0 : Number(existingItem.pv) / Number(existingItem.quantity);
      let total = Number(existingItem.price) * Number(existingItem.quantity);
      if(product.quantity >1){
      this.updateQuantity(
        existingItem.product_id,
        existingItem.quantity = (product.quantity),
        total,
        basePv
      );
    }
    else{
        this.updateQuantity(
          existingItem.product_id,
          existingItem.quantity +=1,
          total,
        basePv
      );
    }
      
      showToast('addToCart');
    },
    async addToCartQueue(product, isFreeItem, isAddedItem) {
      const userStore = useUserStore();
    
      // Push the product to the queue
      userStore.productQueue.push({
        product:product,
        isFreeItem:isFreeItem,
        isAddedItem:isAddedItem,
      });
    
      console.log("Product added to queue:", userStore.productQueue);
    },
    async handlePostLoginCart(product, isFreeItem,isAddedItem=false) {
      console.log('item in helper',isFreeItem,isAddedItem)
      const { cartService } = useAuthenticatedApi();
      const userStore = useUserStore();
      let shippingAddress = computed(() => userStore.shippingAddress);
    
      if (!shippingAddress.value && (!isFreeItem && !isAddedItem)) {
        // Call addToCartQueue after processing the product
        await this.addToCartQueue(product, isFreeItem, isAddedItem);
        eventBus.panelOpen("Change Address");
        return;
      }
    
      let cartId = userStore.cartId || await this.createNewCart();
      console.log(cartId, 'before cartitem0');
      const cartItemPayload = createCartItemPayload(cartId, product, product.quantity, isFreeItem,isAddedItem);
      // console.log(cartId, 'cartItemPayload2');
      if (!isFreeItem && !isAddedItem) {
        const result = await cartService.createCartItem(cartItemPayload);
        console.log('added item in cart',product)
        if (result.status === 200) {
          console.log('added item in cart.js',result)
          this.updateCartSchema(result.data.items || []);
          showToast('addToCart');
        } else {
          showToast('error');
        }
      } else {
        const response = await productService().getProductByCommaSeparation(product.product_code);
        let itemResponse =[];
        itemResponse = await response.data?.products?.at(0);
        let freeCartItemPayload = createCartItemPayload(cartId, await itemResponse, (product.quantity||1), isFreeItem,isAddedItem);
        // ...itemResponse.data,
        console.log('item added', freeCartItemPayload, itemResponse);
        if(isAddedItem){
          freeCartItemPayload=this.checkDiscount(product,freeCartItemPayload);
          console.log(freeCartItemPayload,'>>after discount');
        }
        this.items.push({ 
          cv:false,
          detail:{
            ...freeCartItemPayload,
            product_code:product.product_code,
            product_id:product.product_code,
            price:Number(product.unitRate),
            base_price:Number(product.unitRate),
            quantity:product.quantity|| 1,
            total_pv:Number(product.unitPv?product.unitPv:freeCartItemPayload.pv)* Number(product.quantity||1),
            base_pv:Number(product.unitPv?product.unitPv:freeCartItemPayload.pv),
            dp:Number(product.unitPv?product.unitPv:freeCartItemPayload.pv)*Number(product.quantity|| 1),
            offer_code:product.offer_code,
            isFreeItem:isFreeItem,
            isAddedItem:isAddedItem,
            thumbnail:itemResponse.thumbnail,
            uom:itemResponse.uom,
            weight:product.weight||0,
            total:Number(product.totalAmount?product.totalAmount:freeCartItemPayload.total_with_discount) || 0,
            base_total:Number(product.totalAmount?product.totalAmount:freeCartItemPayload.total_with_discount) || 0,
            final_total:Number(product.totalAmount?product.totalAmount:freeCartItemPayload.total_with_discount) || 0,
            discount_percent: Number(product.discount_percentage?product.discount_percentage:freeCartItemPayload.discount_percent) || 0,
            total_weight:0,
            base_total_weight:0,
            mrp:freeCartItemPayload.mrp,
            url_key:itemResponse.url_key,
            tax_amount:0
          } ,
          url_key:itemResponse.url_key,
          detail_name:itemResponse.name,
          price:Number(product.unitRate),
          quantity:product.quantity|| 1,
          product_id:product.product_code,
          pv:freeCartItemPayload?.pv,
          offer_code:product.offer_code,
          isFreeItem:isFreeItem,
          discount_percent: product.discount_percentage,
          thumbnail:itemResponse.thumbnail,
          uom:itemResponse.uom
        });
        console.log('free item added',this.items,itemResponse);
      }
      // console.log('end');
    },
    
    handlePreLoginCart(product) {
      if(product.quantity==null){
        product.quantity=1;
      }
      const cartItemPayload = createCartItemPayload(null, product, product.quantity);
      this.items.push({
        detail:cartItemPayload,
        // ...product,
        detail_name: product.detail_name,
          price:Number(product.price), 
          product_id:product.sku,
          pv:product.pv,
          // cv:product.cv,
          quantity:Number(product.quantity),
          thumbnail:product.thumbnail,
          uom:product.uom,
          url_key:product.url_key,
          isLocalCart:true,
        // product_id: product.sku,
        // quantity: product.quantity || 1
      });
      showToast('addToCart');
    },
    async removeFromCart(productId,isFreeItem,isAddedItem=false) {
      const userStore = useUserStore();
      const item = this.getItemByProductId(productId,isFreeItem,isAddedItem);
      console.log(item, 'item to be removed',productId,isFreeItem,isAddedItem);
      if (item && userStore.isLoggedIn && !item.isFreeItem ) {
        await this.handleLoggedInCartItemRemoval(item);
      } else {
        this.handleGuestCartItemRemoval(productId,isFreeItem);
        // await this.handleLoggedInCartItemRemoval(item);
      }
    },
    
    getItemByProductId(productId,isFreeItem,isAddedItem) {
      if(isFreeItem==null|| isFreeItem==undefined){
        isFreeItem=false;
      }
      if(isAddedItem==null|| isAddedItem==undefined){
        isAddedItem=false;
      }
      if(isFreeItem==true){
        return this.items.find((item) => item.product_id === productId && item.detail?.additional?.isFreeItem==isFreeItem);
      }else if(isAddedItem == true){
        console.log(this.items.find((item) => item.product_id === productId && item.detail?.additional?.isAddedItem==isAddedItem), 'items');
        return this.items.find((item) => item.product_id === productId && item.detail?.additional?.isAddedItem==isAddedItem);
      }
      else
      {
        return this.items.find((item) => item.product_id === productId);
      }
    },
    
    async handleLoggedInCartItemRemoval(item) {
      const { cartService } = useAuthenticatedApi();
      
      const result = await cartService.deleteCartItem(item.detail.id, item.detail);
      
      if (result.status === 200) {
        this.updateCartSchema(result.data.items);
      } else {
        showToast('error');
      }
    },
    
    handleGuestCartItemRemoval(productId,isFreeItem) {
      let filteredItems = [];
      if(isFreeItem==true){
        filteredItems = this.items.filter((item) => {
          return item.detail.additional?.isFreeItem != true;
        });
        console.log(
          filteredItems = this.items.filter((item) => {
            return item.detail.additional?.isFreeItem != true;
          })
        ,'manual-filter');
        this.items.filter((item) => {
          if(item.detail.additional?.isFreeItem || item.detail.additional?.isAddedItem){
            this.handleLoggedInCartItemRemoval(item)
          }
        });
      }else{
        filteredItems = this.items.filter((item) => {
          return item.product_id !== productId ;
        });
      }
      this.items =filteredItems;
      // this.updateCartSchema(this.items, false, false);
      console.log(this.items,'after delete - items');
      // showToast('removeFromCart');
    },
    async updateQuantity(productId, quantity ) {
      const item = this.getItemByProductId(productId);
      console.log(item,quantity,productId);
    
      if (!item) return;
    
      if (quantity > 0) {
        if(await this.checkInventory({sku:productId,quantity})){
          await this.handleQuantityUpdate(item, quantity);
        }else{
          // showToast('warning',{,essage:'out of stock'});
        }
      } else {
        this.removeFromCart(productId);
      }
    },
    
    async handleQuantityUpdate(item, quantity) {
      const userStore = useUserStore();
      
      if (userStore.isLoggedIn) {
        console.log(item,quantity);
        await this.updateLoggedInUserQuantity(item, quantity);
      } else {
        this.updateGuestUserQuantity(item, quantity);
      }
    },
    
    async updateLoggedInUserQuantity(item, quantity) {
      const { cartService } = useAuthenticatedApi();
      
      if (item.detail && item.detail.id) {
        const updatedItemPayload = this.updateCartItemPayload(item, quantity);
        console.log(updatedItemPayload,'updated Item');
        const result = await cartService.updateCartItem(item.detail.id, updatedItemPayload);
        
        if (result.status === 200) {
          this.updateCartSchema(result.data.items,false,false);
        } else {
          showToast('error');
        }
      } else {
        // Item is not in cart, adding it
        await this.addToCart({ ...item, quantity: quantity + item.quantity });
      }
    },
    
    updateGuestUserQuantity(item, quantity) {
      item.quantity = parseInt(quantity);
      // showToast('quantityUpdated');
    },
    
    updateCartItemPayload(item, quantity) {
      let basePrice = item.cv === false ? Number(item.detail?.base_price) : Number(item.detail?.base_price);
    
      const total = basePrice * quantity;
      const totalPv = Number(item.detail?.base_pv) * quantity;
      // const additional = item.additional ? { ...item.additional, ...additionalData } : additionalData;
      
      return {
        // ...item.detail,
        cart_id:item.detail.cart_id,
        cv: false,
        is_cv: false,
        quantity: Number(quantity),
        base_price: basePrice,
        total,
        total_pv: totalPv
      };
    },
    async clearCart() {
      this.items = []
    },
    isInCart(productId) {
      return this.items.some((item) => (item.product_id === productId || item.detail?.product_id === productId));
    },
    async fetchCart(isApplyingOffer=false,isRevertPoints=false){
      const userStore = useUserStore();
      const { cartService } = useAuthenticatedApi();
      if(userStore.isLoggedIn){
        const result = await cartService.getCart();
        if(result.status==200){
          // console.log(result.data.cart);
          userStore.setCartId(result.data.cart);
          console.log(isApplyingOffer,isRevertPoints,'in fetch cart');
          await this.updateCartSchema(result?.data?.items||[],isApplyingOffer,isRevertPoints);
          // await this.updateCartSchema(result?.data?.items||[],true)
        }
      }
    },
    async createNewCart(){
      const { cartService } = useAuthenticatedApi();
      const result = await cartService.createCart();
      if(result.status==200){
        useUserStore().setCartId(result.data.cart.id);
        return result.data.cart.id
      }
    },
    
    removeOffer(item){
      if (item.offer_code!='' || item.detail?.offer_code!='') {
        if(item.additional?.isAddedItem==true){
          console.log(item,'going to be deleted1')
          this.removeFromCart(item.product_id,false,item.additional?.isAddedItem);
        }
        else if (Number(item.discount_percent) > 0) {
          item.base_price = Number(item.price);
          item.total_price = Number(item.quantity) * Number(item.price);
          item.tax_category_id = 0;
          item.base_pv = Number(item.pv);
          item.total_pv = Number(item.pv) * Number(item.quantity);
          // item.cv = false;
          item.discount_percent = 0;
          item.discount_amount = 0;
          item.base_discount_amount = 0;
          item.final_total = 0;
          item.total_with_discount = 0;
          item.base_dis_amt = 0;
          item.dis_per_pv = 0;
          item.dis_amt_pv = 0;
          item.base_dis_amt_pv = 0;
          item.offer_code='';
        }
        else if(item.additional?.isFreeItem==true){
          console.log(item,'going to be deleted')
          this.removeFromCart(item.product_id,true);
        }
        
        this.setOffer(1);
        this.setOfferMessage('');
        console.log(item,'>>discount')
      }
      return item;
    },
    async removeItemOffers(cartItems) {
      // Use this.items if no specific items are provided
      if (!cartItems) {
        cartItems = this.items;
      }
    
      let updatedItems = [];  // To store updated items
    
      // Loop through each item and remove the offer
      cartItems.forEach((item) => {
        // Remove offer from the item
        console.log(item,'in remove offers')
        if(item.detail?.isFreeItem || item.detail?.isAddedItem){
          this.removeOffer(item.detail);
        }else{
          let finalItem = this.removeOffer(item.detail);
          console.log(finalItem,'after removal')
          // Push the updated item (with updated detail) to the updatedItems array
          updatedItems.push({ ...item, detail: finalItem });
        }
        
      });
    
      // Set the cart with updated items
      this.setCart(updatedItems);
    },
    async updateCartSchema(items,isApplyingOffer,isRevertPoints){
      const updated = [];
      if(isApplyingOffer==null ||isApplyingOffer==undefined){
        isApplyingOffer=false;
      }
      if(items==null){
        items = this.items;
      }
      items.forEach( (item,index)=>{
        // let item2= item;
        console.log(isApplyingOffer,items,'single-item',item);
        
        const product = {
          detail_name: item.name,
          price:Number(item.price),
          product_id:item.product_id,
          pv:item.pv,
          cv:item.cv,
          quantity:Number(item.quantity),
          thumbnail:item.thumbnail,
          uom:item.uom,
          url_key:item.url_key,
        };
        if (!isApplyingOffer) {
          console.log(item,'before remvoe offer')
          let finalItem = this.removeOffer(item);
          item={...finalItem,...item};
          console.log(item,'after>>>>>>>>>>>..')
        }
        if((item.tax_category_id>0 || item.cv==true) && isRevertPoints){
          item.base_price = Number(item.price);
          item.total_price = Number(item.quantity) * Number(item.price);
          item.tax_category_id = 0;
          item.is_cv=false;
          // item.cv=false;
          // alert('in tax category')
          item.base_pv = Number(item.pv);
          item.total_pv = Number(item.pv) * Number(item.quantity);
          this.updateCartItem(item.product_id,item,false);
        }
        // Check if product already has values
        // const existingItem = updated.find(
        //   (existing) => existing.product_id === item.product_id
        // );
      
        // if (existingItem) {
          // If product exists, just update the detail field
          // existingItem.detail = item;
        // } else {
          if (isApplyingOffer) {
            // Update the existing item in place within the items array
            if(item.detail){
              items[index] = {...items[index], ...item  };
            }else{
              items[index] = {...items[index], detail:{...item},detail_name: item.name  };
            }
          } else{
            // Otherwise, push a new product with details
            updated.push({ ...product, detail: item });
          }
        // }
      })
      if (isApplyingOffer) {
        console.log('finalItems when appliedoffer',items)
        this.setCart(items); // Update the cart with the modified items array
      } else {
        this.setCart(updated); // Update the cart with the new products array
      }
    },
    async updateCartActions (mca_no,newLogin=false){
      try {
        const { cartService } = useAuthenticatedApi();
        const cartdata = await cartService.getCart(mca_no);

        const cartItems = JSON.parse(JSON.stringify(this.items));
  
        if(cartdata.status==200){
          // console.log('from udpatecart');
          // console.log(cartdata.data);
          const cartId = cartdata?.data?.cart?.id;
          useUserStore().setCartId(cartId);
          if(!cartId) return;
          
          if(newLogin){
            cartItems.forEach((item)=>{
              const already_in_cart = cartdata.data.items.find(p=>p.product_id==item.product_id)
              if(!already_in_cart){
                // this.addToCart({...item.detail,cart_id:cartId,isLocalCart:false});
                cartService.createCartItem({...item.detail,cart_id:cartId,isLocalCart:false});
              }
              else{
                console.log("newwewm",item)
                cartService.updateCartItem( already_in_cart.detail.id,{
                  ...already_in_cart.detail,
                  quantity: Number(already_in_cart.quantity)+Number(item.quantity)
                })
                //replace this if other things in update collapse
                // this.updateQuantity(item.product_id, Number(already_in_cart.quantity||1)+Number(item.quantity));
              }
            })
          }
        }
        this.clearCart()
        if(newLogin){
          // fetch cart again as new items or existing items have updated
          this.fetchCart();
          // this.updateCartSchema(cartdata.data.items)
        }else{
          this.updateCartSchema(cartdata.data.items)
        }
      } catch (error) {
        console.log(error);
      }
    },
    async updateCartItemDetails(productId,updates,isApplyingOffer){
      
      let item = this.items.find((item) => item.product_id == productId);
      if(isApplyingOffer==null|| isApplyingOffer==undefined){
        isApplyingOffer=false;
      }
      // console.log(this.items, productId, updates);
    
      if (item) {
        // console.log(productId);
    
        // Avoid recursion by checking if updates actually change the current item details
        const isDifferent = Object.keys(updates).some(key => item.detail[key] !== updates[key]);
    
        if (isDifferent && updates.quantity > 0) {
          const userStore = useUserStore();
          const { cartService } = useAuthenticatedApi();
    
          if (userStore.isLoggedIn) {
            if (item.detail && item.detail.id) {
              // Update item detail only if necessary (to avoid recursion)
              item.detail = { ...item.detail, ...updates };  // Shallow merge updates into item detail
              console.log('Updated item detail:updateCartItemDetails', item.detail,updates);
              // console.log(updatedItems);
              if(isApplyingOffer){
                // updatedItems={...updates};
                let updatedItemList = this.items.map((existingItem) => {
                  if (existingItem.detail.id === item.detail.id) {
                    return {  ...existingItem, 
                      detail: { ...existingItem.detail,...updates}
                     };
                    // return { ...existingItem, detail: { ...existingItem.detail, ...updatedItems,offer_code:'' } };
                    //offer_code is written separately to handle pinia promotion addition case
                  }
                  return existingItem;  // return other items unchanged
                });
                this.updateCartSchema(updatedItemList,isApplyingOffer);
              }else{
                const result  = await cartService.updateCartItem(item.detail.id, updates);
                if(isApplyingOffer==null|| isApplyingOffer==undefined || !isApplyingOffer){
                  this.updateCartSchema(result.data.items || []);
                }
              }
              // Uncomment for server-side update
              // await cartService.updateCartItem(item.detail.id, updatedItems);
            }
          }
        }
      }
    },
    async updateCartItem(productId, updates,isApplyingOffer) {
      let item = this.items.find((item) => item.product_id == productId);
      if(isApplyingOffer==null|| isApplyingOffer==undefined){
        isApplyingOffer=false;
      }
      // console.log(this.items, productId, updates);
    
      if (item) {
        // console.log(productId);
    
        // Avoid recursion by checking if updates actually change the current item details
        const isDifferent = Object.keys(updates).some(key => item.detail[key] !== updates[key]);
    
        if (isDifferent && updates.quantity > 0) {
          const userStore = useUserStore();
          const { cartService } = useAuthenticatedApi();
    
          if (userStore.isLoggedIn) {
            if (item.detail && item.detail.id) {
              // Update item detail only if necessary (to avoid recursion)
              item.detail = { ...item.detail, ...updates };  // Shallow merge updates into item detail
              console.log('Updated item detail:updateCartItem', item.detail,updates);
              let updatedItems ={};
              // Uncomment for server-side update
              updatedItems={  
                id: item.detail.id,
                cart_id: item.detail.cart_id,
                product_id:item.detail.product_id,
                cv: updates.cv,
                
                // offer_code:updates.offer_code ,
                // base_price:updates.base_price,
                // base_price:updates.base_price,
                // total_price:updates.total_price,
                
                // pv:item.detail.pv,
                // base_pv:updates.base_pv,
                // total_pv:updates.total_pv
              };
              // console.log(updatedItems);
              if(isApplyingOffer){
                updatedItems={...updates};
                let updatedItemList = this.items.map((existingItem) => {
                  if (existingItem.detail.id === item.detail.id) {
                    return {  ...existingItem, 
                      detail: { ...existingItem.detail, ...updatedItems}
                     };
                    // return { ...existingItem, detail: { ...existingItem.detail, ...updatedItems,offer_code:'' } };
                    //offer_code is written separately to handle pinia promotion addition case
                  }
                  return existingItem;  // return other items unchanged
                });
                this.updateCartSchema(updatedItemList,isApplyingOffer);
              }else{
                const result  = await cartService.updateCartItem(item.detail.id, updatedItems);
                if(isApplyingOffer==null|| isApplyingOffer==undefined || !isApplyingOffer){
                  this.updateCartSchema(result.data.items || []);
                }
              }
              // Uncomment for server-side update
              // await cartService.updateCartItem(item.detail.id, updatedItems);
            }
          }
        }
      }
    },
    async updateFinalCartItem(productId,updates){
      let item = this.items.find((item) => item.product_id == productId);
      
      // console.log(this.items, productId, updates);
    
      if (item) {
        const isDifferent = Object.keys(updates).some(key => item.detail[key] !== updates[key]);
    
        if (isDifferent && updates.quantity > 0) {
          const userStore = useUserStore();
          const { cartService } = useAuthenticatedApi();
    
          if (userStore.isLoggedIn) {
            if (item.detail && item.detail.id) {
              // Update item detail only if necessary (to avoid recursion)
              item.detail = { ...item.detail, ...updates };  // Shallow merge updates into item detail
              console.log('Updated item detail:finalCartUpdate', item.detail,updates);
              const result  = await cartService.updateCartItem(item.detail.id, item.detail);
              this.updateCartSchema(result.data.items || []);
            }
          }
        }
      }
    }
    
  }
});
